import { Select, MenuItem, InputLabel, SelectChangeEvent, CircularProgress, Stack } from '@mui/material'
import { FC } from 'react'
import { ISelectUiKitProps } from './interfaces'
import { SelectUiKitContainer } from './styles'

const SelectUiKit: FC<ISelectUiKitProps> = ({ register, name, className, validation, items, label, onchange, ...props }) => {
  const registerProps = register && name && register(name, validation)
  const handleChange = (event: SelectChangeEvent<any>) => onchange && onchange(event.target.value as string)

  return (
    <SelectUiKitContainer fullWidth size="small" className={className}>
      <InputLabel id="selectUiKit-label" size="small">
        {label}
      </InputLabel>
      <Select
        {...registerProps}
        {...props}
        labelId="selectUiKit-label"
        label={label}
        size="small"
        onChange={handleChange}
        MenuProps={{
          PaperProps: {
            className: 'select-styles',
          },
        }}
      >
        {items.map((item, i) => (
          <MenuItem key={i} value={item.value}>
            {item.label}
          </MenuItem>
        ))}
        {!items.length && (
          <Stack alignItems="center">
            <CircularProgress color="primary" size={20} className="mr-3" />
          </Stack>
        )}
      </Select>
    </SelectUiKitContainer>
  )
}

export default SelectUiKit
